document.addEventListener("DOMContentLoaded", function () {
  // Forms
  let formStarted = new Set();
  document.querySelectorAll("form").forEach((form) => {
    form.addEventListener("focusin", function (event) {
      if (!formStarted.has(form)) {
        formStarted.add(form);
        console.log(form);
        Shopify.analytics.publish("form_start", {
          form_id: form.id || "unknown",
          form_name: form.name || "unknown",
          form_destination: form.action || "unknown",
        });
      }
    });

    form.addEventListener("submit", function (event) {
      let submitButton = form.querySelector("[type=submit]");
      Shopify.analytics.publish("form_submit", {
        form_id: form.id || "unknown",
        form_name: form.name || "unknown",
        form_destination: form.action || "unknown",
        form_submit_text: submitButton
          ? submitButton.innerText.trim()
          : "unknown",
      });
    });
  });

  // Login
  const loginForm = document.getElementById("customer_login");
  if (loginForm) {
    loginForm.addEventListener("submit", function (event) {
      Shopify.analytics.publish("login", {});
    });
  }

  // Signup
  const signupForm = document.getElementById("create_customer");
  if (signupForm) {
    signupForm.addEventListener("submit", function (event) {
      Shopify.analytics.publish("sign_up", {});
    });
  }

  // Contact Forms
  const contactForms = document.querySelectorAll(
    'form#contact_form, form[action*="contact_form"]'
  );
  contactForms.forEach((form) => {
    form.addEventListener("submit", function (event) {
      // Extract the email address
      const emailInput = this.querySelector(
        'input[type="email"], input[name="contact[email]"]'
      );
      const email = emailInput ? emailInput.value : null;
      Shopify.analytics.publish("email_signup", { email: email });
    });
  });

  // Ateliers
  const formKeys = ["form_GBlGFBqE_P", "form_C1EhGGi3U2", "form_pEqB_2t5qR"];
  formKeys.forEach((formKey) => {
    const form = document.querySelector(`[data-form-key="${formKey}"]`);
    if (form) {
      // Track form submission
      form.addEventListener("submit", function (event) {
        Shopify.analytics.publish("booking_request", {
          location: formKey === "form_GBlGFBqE_P" ? "rome" : "milan"
        });
      });
    }
  });
});
